export const DEBUG = false;
export const COLORS = {
  main: "#5FD49B",
  secondary: "#FF8547",
  highlight: "#BAFFFF"
};

export const DB_PATH = "danceoff/leaderboard";
